/* ============
 * Mutation types for the account module
 * ============
 *
 * The mutation types that are available
 * on the auth module.
 */

export const LIST = 'LIST';
export const EXCEL_FILE_LIST = 'EXCEL_FILE_LIST';

export default {
  LIST,
  EXCEL_FILE_LIST,
};
